import * as React from "react";

import UsersTable from "./UsersTable";

import Box from '@mui/material/Box';
import AppPage from "@/ui/AppPage/AppPage";

function UsersPage() {
  return (
    <AppPage>
      <UsersTable />
    </AppPage>
  );
}

export default UsersPage;
